/* ------------------------------------------------------------------
   SAYSIRI - cascading variant availability  (v14)

   History
   -------
   v13 marked an option value sold out only if it was unavailable against
   EVERY other currently selected option. On a sparse matrix that reads as
   broken: with Pink / S - No zip held, the White swatch struck through even
   though White had three units, because White has no S - No zip.

   v14 uses the cascade rule the shopper actually reasons with:

     an option value at position N is judged only against the options
     BEFORE it (positions 0..N-1), never against the ones after it.

   So the colour swatch answers "is this colourway buyable at all?" and the
   size row answers "which sizes exist in the colour I picked?". Picking a
   colour then narrows the sizes, which is how every size/colour picker the
   shopper has used elsewhere behaves.

   It also snaps: choosing a colour that does not stock the size currently
   held moves the selection to the first size that colour does stock, so the
   shopper never lands on Out of Stock straight after clicking a live swatch.

   Purely additive - touches no existing markup or styles. Sold-out options
   stay clickable so a shopper is never trapped in a dead end.
   Remove the single script_tag line in theme.liquid to revert.
   ------------------------------------------------------------------ */

(function () {
  'use strict';

  var BUTTONS = '.spdp-colours [data-option-index], .spdp-sizes [data-option-index]';

  function init(varsEl) {
    var variants;
    try {
      variants = JSON.parse(varsEl.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    var scope = varsEl.closest('.shopify-section') || document;

    /* The section emits a companion tag: { colorIndex, sizeIndex, optionCount }.
       Fall back to 0 for colour if it is missing. */
    var colourIndex = 0;
    var optsEl = varsEl.id ? document.getElementById(varsEl.id.replace('spdpVariants-', 'spdpOptions-')) : null;
    if (optsEl) {
      try {
        var meta = JSON.parse(optsEl.textContent);
        if (meta && typeof meta.colorIndex === 'number') colourIndex = meta.colorIndex;
      } catch (e) {
        /* keep the default */
      }
    }

    var snapping = false;

    function buttons() {
      return Array.prototype.slice.call(scope.querySelectorAll(BUTTONS));
    }

    function currentSelection() {
      var sel = {};
      buttons().forEach(function (b) {
        if (b.classList.contains('is-selected')) {
          sel[parseInt(b.getAttribute('data-option-index'), 10)] = b.getAttribute('data-value');
        }
      });
      return sel;
    }

    /* Cascade: judge position N against positions 0..N-1 only. */
    function isAvailable(idx, val, sel) {
      return variants.some(function (v) {
        if (!v.available) return false;
        if (!v.options || v.options[idx] !== val) return false;
        for (var j = 0; j < idx; j += 1) {
          if (sel[j] != null && v.options[j] !== sel[j]) return false;
        }
        return true;
      });
    }

    function refresh() {
      var sel = currentSelection();

      buttons().forEach(function (b) {
        var idx = parseInt(b.getAttribute('data-option-index'), 10);
        var val = b.getAttribute('data-value');
        var available = isAvailable(idx, val, sel);

        b.classList.toggle('is-oos', !available);

        var base = b.getAttribute('data-availability-label');
        if (base === null) {
          base = (b.getAttribute('aria-label') || b.textContent || '').trim();
          base = base.replace(/\s+—\s+out of stock$/i, '');
          b.setAttribute('data-availability-label', base);
        }
        b.setAttribute('aria-label', available ? base : base + ' — out of stock');
      });
    }

    /* If the held size is not stocked in the colour just chosen, move to the
       first size that is. Uses the theme's own click handler, so selection,
       price, media and the add-to-cart button all update the normal way. */
    function snapToStockedSize() {
      if (snapping) return;

      var later = buttons().filter(function (b) {
        return parseInt(b.getAttribute('data-option-index'), 10) !== colourIndex;
      });
      if (!later.length) return;

      var heldIsDead = later.some(function (b) {
        return b.classList.contains('is-selected') && b.classList.contains('is-oos');
      });
      if (!heldIsDead) return;

      var target = later.filter(function (b) {
        return !b.classList.contains('is-oos');
      })[0];
      if (!target) return;

      snapping = true;
      target.click();
      window.setTimeout(function () {
        snapping = false;
        refresh();
      }, 0);
    }

    scope.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || typeof t.closest !== 'function') return;

      var btn = t.closest('[data-option-index]');
      if (!btn) return;

      var wasColour = parseInt(btn.getAttribute('data-option-index'), 10) === colourIndex;

      window.setTimeout(function () {
        refresh();
        if (wasColour) snapToStockedSize();
      }, 0);
    });

    refresh();
  }

  function boot() {
    var nodes = document.querySelectorAll('[id^="spdpVariants-"]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
